import { get } from 'lodash'
import axios from 'axios'
import config from '../../../../../config'
import toast from 'react-hot-toast'
import { TenantSubscription } from '../../../interfaces/interface'

const apiServerUrl = get(config, 'apiServerUrl')

const postSubscriptionDetails = async ({
    businessSubscriptionDetails,
}: {
    businessSubscriptionDetails: TenantSubscription
}) => {
    return axios
        .post(
            `${apiServerUrl}/admin/subscription/`,
            businessSubscriptionDetails
        )
        .then((res) => {
            return res.status
        })
        .catch((err) => {
            toast(err)
        })
}

const editSubscriptionDetails = async ({
    businessSubscriptionDetails,
}: {
    businessSubscriptionDetails: TenantSubscription
}) => {
    return axios
        .put(
            `${apiServerUrl}/admin/subscription/`,
            businessSubscriptionDetails
        )
        .then((res) => {
            return res.status
        })
        .catch((err) => {
            toast(err)
        })
}

const getModulesList = () => {
    const response = axios
        .get(`${apiServerUrl}/admin/subscription/modules`)
        .then((res) => {
            return res.data
        })
        .catch((err) => {
            toast(err)
        })
    return response
}

export { postSubscriptionDetails, editSubscriptionDetails, getModulesList }
